import type { ReactNode } from "react";

import { useCurrentUserContext } from "@/contexts";
import { ForbiddenPage } from "@/ui";

export type SuperAdminGuardProps = {
  children: ReactNode;
};

export const SuperAdminGuard = ({ children }: SuperAdminGuardProps) => {
  const { currentUser, loading } = useCurrentUserContext();

  if (loading) {
    return null;
  }

  if (!currentUser) {
    return null;
  }

  if (currentUser.role !== "superAdmin") {
    return <ForbiddenPage />;
  }

  return <>{children}</>;
};
